import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function H() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const [isEnter, setIsEnter] = useState(false);

    useEffect(() => {
        AniContainer.create({
            triggerElement: '.d2x-detail-H',
            triggerHook: 1,
            offset: '40%',
            duration: '10%',
            onEnter: () => {
                setIsEnter(true);
            },
            isGpu: false,
        });
    }, []);

    return (
        <div
            className={`d2x-detail-H ${css.d2xDetailH} GtmModuleData-section`}
            id="d2x-detail-H"
            data-section-id={'d2x-detail-H'}
            data-section-title={t('sec8_title')}
        >
            <div className="text-box">
                <div className="left">
                    <div className="slogan">{t('sec8_slogan')}</div>
                    <div className="title">{t('sec8_title')}</div>
                    <div className="desc">{t('sec8_desc')}</div>
                </div>
                <div className="line"></div>
                <div className="flex-box">
                    <div className={`right ${isEnter ? 'isEnter' : ''}`}>
                        <div className="process-box">
                            <div className="bar-box">
                                <div className="bar bar1">
                                    <div className="process"></div>
                                </div>
                                <div className="text">{t('sec8_process1')}</div>
                            </div>
                            <div className="value-box">
                                <div className="value">{t('sec8_process1_value')}</div>
                                <div className="unit">{t('sec8_unit')}</div>
                            </div>
                        </div>
                        <div className="process-box">
                            <div className="bar-box">
                                <div className="bar bar2">
                                    <div className="process"></div>
                                </div>
                                <div className="text">{t('sec8_process2')}</div>
                            </div>
                            <div className="value-box">
                                <div className="value">{t('sec8_process2_value')}</div>
                                <div className="unit">{t('sec8_unit')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content-box">
                <div className="video-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zg.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zg.jpg')}
                        alt={t('sec8_title')}
                        aria-label={t('sec8_title')}
                    />
                </div>
                <div className="desc-box">
                    <div className="desc">
                        {t.rich('sec8_desc2', {
                            line: (text: any) => <span>{text}</span>,
                        })}
                    </div>
                </div>
            </div>
            <div className="tip">{t('sec8_tip')}</div>
        </div>
    );
}
